import * as IkeModel from '@ikegps/core-shared';
// @todo deprecate use of time-stamp and use moment
import timestamp from 'time-stamp';
import { T, Translate } from '../../../i18n/index';
import type { MithrilVNode } from '../../../mithril';
import { Services } from '../../../services';
import { CollectionEditCtrl } from '../collection.view.ctrl';
import type { CollectionFieldView } from './field.view';

export const DateFieldView: CollectionFieldView<IkeModel.CollectionModelFieldDate> = {
	viewInline(field: IkeModel.CollectionModelFieldDate): string {
		if (!field.hasValue()) {
			return '';
		}

		const date = new Date(field.value);

		if (field.value == null || isNaN(date.getTime())) {
			return Translate(T.DATE_INVALID);
		}

		return timestamp(Services.UserSettings.dateFormat, date);
	},

	viewDetail(field: IkeModel.CollectionModelFieldDate): MithrilVNode {
		return null;
	},

	viewEdit(field: IkeModel.CollectionModelFieldDate, state: CollectionEditCtrl): MithrilVNode | string {
		return this.viewInline(field, state);
	},
};
